import update from 'react-addons-update';
import {SHOW_ATTACHMENTS_IN_GALLERY, CLOSE_GALLERY} from '../actions';

const initialState = {
  attachments: null,
  selectedIndex: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ATTACHMENTS_IN_GALLERY:
      return update(state, {
        attachments: {$set: action.payload.attachments},
        selectedIndex: {$set: action.payload.selectedIndex}
      });
    case CLOSE_GALLERY:
      return update(state, {attachments: {$set: null}, selectedIndex: {$set: null}});
    default:
      return state;
  }
};
